(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/link-navigation/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/app/link-navigation/assets/javascripts/init.js'); 
(function(_, svs) {
  'use strict';

  svs.app = svs.app || {};
  svs.app.behaviors = svs.app.behaviors || {};
})(this._, this.svs);

 })(window);